import React from 'react';
import { Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
const ClaimGroupSelector = _ref => {
  let {
    accountType,
    loading,
    company,
    claimGroup,
    allClaimGroups
  } = _ref;
  const history = useHistory();
  const user = useSelector(state => state.auth.user);
  const handleClaimGroupChange = async e => {
    const selectedClaimGroupId = e.target.value;
    if (accountType === 'customer') {
      var _user$user_accesses;
      const hasDashboardAccess = (_user$user_accesses = user.user_accesses) === null || _user$user_accesses === void 0 || (_user$user_accesses = _user$user_accesses.find(uA => uA.rollable_id === Number(selectedClaimGroupId) && uA.rollable_type === 'ClaimGroup')) === null || _user$user_accesses === void 0 ? void 0 : _user$user_accesses.dashboard_access;
      if (hasDashboardAccess) {
        if (process.env.PUBLIC_URL !== '/be' && process.env.PUBLIC_URL !== '/de') {
          if (company.dashboard_type === 'business_unit_intensity_breakdown') {
            window.location.href = "/".concat(accountType, "/claim_groups/").concat(selectedClaimGroupId, "/regular_realtime_dashboard/").concat(company.id);
            return;
          }
          return history.push("/".concat(accountType, "/claim_groups/").concat(selectedClaimGroupId, "/dashboard/").concat(company.id));
        } else if (process.env.PUBLIC_URL === '/de') {
          return history.push("/".concat(accountType, "/claim_groups/").concat(selectedClaimGroupId, "/project_overview"));
        } else {
          return history.push("/".concat(accountType, "/claim_groups/").concat(selectedClaimGroupId, "/claim_group_dashboard"));
        }
      }
      if (process.env.PUBLIC_URL === '/be') {
        return history.push("/".concat(accountType, "/claim_groups/").concat(selectedClaimGroupId, "/claim_group_dashboard"));
      }
    }
    return history.push("/".concat(accountType, "/companies/").concat(company.id, "/").concat(selectedClaimGroupId, "/master"));
  };
  const getClaimGroupOptions = () => {
    const sortedClaimGroupYears = allClaimGroups.sort((a, b) => a.name.slice(-4) > b.name.slice(-4) ? -1 : 1);
    return sortedClaimGroupYears.map(claimGroup => {
      return /*#__PURE__*/React.createElement("option", {
        value: claimGroup.id
      }, claimGroup.name.replace(company.name, '').trim());
    });
  };
  if (!claimGroup) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-2 my-3"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: claimGroup.id,
    onChange: handleClaimGroupChange,
    name: "current_claim_group",
    as: "select",
    size: "md",
    className: "p-1 "
  }, !loading && getClaimGroupOptions()));
};
export default ClaimGroupSelector;